import { IDirectDebitDetails, IFormValidationRules } from '@nx-ng/types';
import { ACCOUNT_NUMBER_REGEX, SORT_CODE_REGEX } from '@nx-ng/util';
import { ValidationService } from './validation.service';

export class DirectDebitValidationService extends ValidationService<IDirectDebitDetails> {
  constructor() {
    super();
  }

  additionalValidation(details?: IDirectDebitDetails): boolean {
    return true;
  }

  rulesFromDefinition(
    obj?: IDirectDebitDetails
  ): IFormValidationRules<IDirectDebitDetails> {
    return {
      fullName: {
        required: true,
      },
      sortCode: {
        required: true,
        pattern: SORT_CODE_REGEX,
      },
      accountNumber: {
        required: true,
        pattern: ACCOUNT_NUMBER_REGEX,
      },
      accountHolderMandate: {
        requiredTrue: true,
      },
      creditCheckAgreement: {
        requiredTrue: true,
      },
    };
  }
}
